import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router/index'
import { resetRouter } from '@/router/index'
const baseURL = process.env.NODE_ENV === 'development' ? '/api' : '/api'
let UNAUTHORIZED = true
const instance = axios.create({
  baseURL,
  // timeout: 1000,
  withCredentials: true
})

// 请求拦截（配置发送的参数）
instance.interceptors.request.use(config => {
  const userInfo = localStorage.getItem('userInfo')
  const token = JSON.parse(userInfo) && JSON.parse(userInfo).token
  if (token) {
    config.headers.token = token
  }
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截（配置返回的数据）
instance.interceptors.response.use(res => {
  if (res.data instanceof Blob) return res // 如何是file 则需要header
  if (res.data.status === 200) {
    return res.data
  } else if(res.config.data && res.config.data.indexOf('isSpec') !== -1) { // 弹窗特殊处理
    return res.data
  } else {
    Message({
      message: res.data.msg,
      type: 'error',
      duration: 1000
    })
  }
}, error => {
  if (error.response.status === 401 && UNAUTHORIZED) {
    UNAUTHORIZED = false
    Message({
      message: '登录过期，请重新登录',
      type: 'error',
      duration: 500
    })
    resetRouter()
    localStorage.clear();
    if (window.self !== window.top) {
      window.top.postMessage('reloadPortal', '*')
    } else {
      setTimeout(() => {
        UNAUTHORIZED = true
        router.push('/login')
      }, 500)
    }
  }
  return Promise.reject(error)
})

const httpParams = function httpParams (url, data) {
  const dataType = typeof data
  if (url.includes('{id}')) {
    const id = dataType === 'object' ? data.id : data
    delete data.id
    return {
      url: url.replace('{id}', id),
      data
    }
  }
  return {
    url,
    data
  }
}

const _get = (url, data = {}) => {
  const params = httpParams(url, data)
  return instance({
    url: params.url,
    method: 'get',
    params: params.data
  })
}
const _post = (url, data = {}, header) => {
  const params = httpParams(url, data)
  const reqConfig = {
    url: params.url,
    method: 'post',
    data: params.data
  }
  if (header) {
    reqConfig.headers = {
      'Content-Type': header
    }
  }
  return instance(reqConfig)
}
const _put = (url, data = {}) => {
  const params = httpParams(url, data)
  return instance({
    url: params.url,
    method: 'put',
    data: params.data
  })
}

const _delete = (url, data = '') => {
  const params = httpParams(url, data)
  return instance({
    url: params.url,
    method: 'delete',
    params: params.data
  })
}

const _downloadFile = (url, data = {}) => {
  const params = httpParams(url, data)
  return instance({
    url: params.url,
    method: 'get',
    params: params.data,
    responseType: 'blob'
  })
}

export {
  _get,
  _post,
  _put,
  _delete,
  _downloadFile
}
